import React from 'react';

export default function CompanyAdminPicker({ users, selected, onChange, disabled = false }) {
  return <fieldset disabled={disabled} style={{ border: '1px solid #cbd5e1', borderRadius: 8, padding: 16, margin: '0 0 20px' }}>
    <legend style={{ fontWeight: 600 }}>Company administrators</legend>
    <p style={{ marginTop: 0, color: '#475569', fontSize: 13 }}>Select one or more users. Each administrator can manage this company’s roles, administrators and privacy.</p>
    <div style={{ maxHeight: 240, overflowY: 'auto' }}>
      {users.map(user => <label key={user.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 0' }}>
        <input type="checkbox" checked={selected.includes(Number(user.id))} onChange={e => onChange(e.target.checked ? [...selected, Number(user.id)] : selected.filter(id => id !== Number(user.id)))} />
        <span>{user.name}{user.email && <small style={{ display: 'block', color: '#64748b' }}>{user.email}</small>}</span>
      </label>)}
    </div>
    {!users.length && <p>No users available.</p>}
    <small>{selected.length} administrator{selected.length === 1 ? '' : 's'} selected</small>
  </fieldset>;
}
